import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function JacketBackDigitizing() {

    const jacketSteps = [
        { number: "01", title: "Submit Your Design", description: "Send your artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Large Design Digitizing", description: "We convert your jacket back design into an optimized embroidery stitch file.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "Refine stitch density, underlay, and details for flawless large embroidery.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, or other required formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Jacket Back Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Large design jacket back embroidery digitizing services in Los Angeles, CA. High-quality stitch files for bold embroidery designs." />
                <meta name="keywords" content="jacket back digitizing, large embroidery digitizing, jacket logo digitizing, back embroidery digitizing services, Los Angeles embroidery digitizing" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Jacket Back Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Jacket Back Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/jacketback1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Large Format. Flawless Execution.</span>
                                <h3 className="case-study-title">Expert Jacket Back Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide specialized jacket back digitizing services in Los Angeles, California, designed to handle large, detailed embroidery designs. Jacket back embroidery requires precise planning of stitch paths, density, and underlay to maintain the integrity of the design across a larger surface area.
                                </p>
                                <p className="case-study-description">
                                    Our team carefully converts your logos, artwork, or custom designs into machine-ready stitch files that preserve clarity, color, and visual impact. Whether it’s for corporate jackets, team apparel, or custom fashion, our jacket back embroidery digitizing services ensure professional, consistent results. If you’re searching for reliable jacket back digitizing near you in Los Angeles, Grand Indigo Embroidery delivers precision and high-quality embroidery files every time.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Engineered for Large-Scale Production</span>
                                <h3 className="case-study-title">Custom Large Design Digitizing for Jackets</h3>
                                <p className="case-study-description">
                                    Our custom jacket back digitizing services are tailored for large embroidery projects, optimizing stitch density and design placement for optimal production results. From detailed logos to full-back designs, we ensure smooth execution on all major embroidery machines without compromising on quality.
                                </p>
                                <p className="case-study-description">
                                    Businesses and organizations across Los Angeles trust us for fast turnaround, professional output, and attention to detail. You can also order jacket back digitizing online to get accurate, ready-to-use stitch files for all your large embroidery projects.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/jacketback2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={jacketSteps} />
                                    
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is jacket back digitizing?"
                                    answer="Jacket back digitizing is the process of converting large logos or designs into machine-readable embroidery files optimized for the back of jackets."
                                />

                                <FaqItem
                                    question="Do you offer jacket back digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional jacket back digitizing services in Los Angeles, California for local and online clients."
                                />

                                <FaqItem
                                    question="How long does jacket back digitizing take?"
                                    answer="Most large jacket designs are digitized within 24–36 hours depending on complexity."
                                />

                                <FaqItem
                                    question="Can I order jacket back embroidery digitizing online?"
                                    answer="Yes, you can easily order jacket back digitizing online with fast turnaround and professional results."
                                />

                                <FaqItem
                                    question="What types of jackets can be embroidered on?"
                                    answer="We can digitize designs for leather jackets, denim jackets, varsity jackets, windbreakers, and more."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
